import { useMutation } from '@apollo/client';

import { CreateMilestoneInput } from '../../apollo/__generated__/graphql';
import { EVENTS } from '../../event/graphql/query/eventsQuery.graphql';
import { MILESTONES } from '../../event/graphql/query/milestonesQuery.graphql';
import { CREATE_MILESTONE } from '../graphql/mutation/createMilestoneMutation.graphql';

export const useCreateMilestoneMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(CREATE_MILESTONE, { onCompleted });

  const createMilestone = (createMilestoneInput: CreateMilestoneInput) => {
    mutate({
      variables: {
        createMilestoneInput,
      },
      refetchQueries: [
        {
          query: MILESTONES,
          variables: { eventId: createMilestoneInput.eventId },
        },
        EVENTS,
      ],
    });
  };

  return { createMilestone };
};
